import BaseReportStore from './base-store'
import allocationStore from 'modules/offer/stores/allocation'
import publisherStore from 'modules/offer/stores/publisher'
import pathStore from 'modules/path/stores/path'
import pathUserProfileStore from 'modules/path/stores/user_profile'

export default new class ProgressionStore extends BaseReportStore {
  constructor() {
    super(true)
  }

  publisher = this.attachEntity(publisherStore, { params: { report: false } })
  path = this.attachEntity(pathStore, { params: { report: false } })
  allocation = this.attachEntity(allocationStore, { labelKey: 'description', params: { report: false } })
  pathUserProfile = this.attachEntity(pathUserProfileStore, { params: { report: false } })

  endpointReport = 'progression'
}